/* istanbul ignore file */

export enum BulkSiteUploadTypeSelection {
    Excel = 0,
    Shapefile = 1
}
